import { useOrgsApi } from 'src/api/db/apiOrgs'
import { useGetOrgId } from 'src/api/helpers/getOrgId'

export const useOrganizationCurrency = () => {
  const org_id = useGetOrgId()
  const { organization, organizationById } = useOrgsApi({ org_id })
  const org = organization?.data ?? organizationById?.data
  return org?.currency ?? 'SEK'
}
